<template>
    <vForm :label-width="80" :model="formdata" inline>
        <!-- 导入模板 -->
        <vFormItem :label="comptitle" style="margin-bottom:10px">
            <vSelect  v-model="typelabel" filterable >
                <vOption v-for="item in erpskuType" :value="item.value" :key="item.value">{{item.label}}</vOption>
            </vSelect>
        </vFormItem>
        <div class="color-error margin-bottom-10">{{erpskutitle}}</div>
        <!-- <compUpload v-bind="getFileProps" @on-close="close" @on-success="success" :warningtitle="warningtitle"></compUpload> -->
        <compMutiUpload v-bind="getFileProps" @on-cancel="close" @on-success="success" />
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props:['erpskutitle','warningtitle','importType','actionurl','downrul','comptitle','detailid'],
    components: {
		compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
	},
    data(){
        return {
            carrierCode:'',
            carrierServiceCode:'',
            labelValue:"",
            typelabel:'',
            dataList: [],
            erpskuType:[
                {value:'other',label:'Other'},
                {value:'shiplabel',label:'ShippingLabel'},
                {value:'packlist',label:'PackingList'},
                {value:'bol',label:'BOL'},
                {value:'cartonlabel',label:'CartonLabel'},
                {value:'palletlabel',label:'PalletLabel'},
                {value:'itemlabel',label:'ItemLabel'},
            ],
            // required: [{
            //     required: true,
            //     message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            // }],

        }
    },
    // mounted(){
    //     console.log(this.comptitle)
    // },
    computed: {
        getFileProps() {
            let datajson;
            if(this.detailid){
                datajson={
                    id:this.detailid,
                    type:this.typelabel
                }
            }else{
                datajson={
                    type:this.typelabel
                }
            }
			return {
				action: process.env.VUE_APP_APIURL_FBB + this.actionurl,
				name: "multipartFile",
				data: datajson,
                multiple: true,
                formatter: (res) => {
                    this.$emit('on-success',res)
                    return res.data;
                },
                beforeUpload:(file)=>{
                    if(file.length <= 0) return false;
                    if(file.length >0 && !this.typelabel){
                        this.$Message.error({
                                content: "请选择文件类型！",
                                duration: 30,
                                closable: true,
                            });
                        return false
                    }
                    return true
                },
                // action: process.env.VUE_APP_APIURL_FBB + this.actionurl,
				// name: "multipartFile",
				// data: datajson,
                // download:()=>{
                //     if(this.importType){
                //         this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + this.downrul, {importType:this.importType}, 'download')
                //     }else{
                //         this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + this.downrul, {}, 'download')
                //     }
                // }
			}
		},
    },
    methods: {
        close(){
            this.$emit('on-close')
        },
        success(res){
            this.$Message.success({
                content: "Operate Successful",
                duration: 30,
                closable: true,
            });
            // this.$emit('on-success',res)
            this.close()
        }
    }
}
</script>
